<h1>Utwórz organizację</h1>
<p class="font-bold">
  Zapraszamy podmioty inne niż gminy do utworzenia konta organizacji w obszarze
  Rejestr Żłobków
</p>
<p>
  Wnioski <strong>RKZ-2</strong> (o aktualizację albo zmianę danych),
  <strong>RKZ-3</strong> (o wykreślenie żłobka/klubu dziecięcego/ opiekuna
  dziennego), <strong>RKZ-4</strong> (sprawozdanie z działalności żłobków,
  klubów dziecięcych i dziennych opiekunów), <strong>RKZ-5</strong> (informacja
  o dzieciach uczęszczających do instytucji) oraz
  <strong>RKZ-8</strong> (informacja o standardach opieki) można składać tylko
  po utworzeniu konta organizacji (tj. po przełączeniu się z kontekstu osoby
  fizycznej na kontekst organizacji).
</p>

<p style="margin-bottom: 1rem; margin-top: 0.1rem">
  Pobierz:
  <a
    class="instruction-label"
    href="/api/instructions/instrukcja_zakladania_konta_organizacji.pdf"
    target="_blank"
    rel="noopener noreferrer"
    >Instrukcja zakładania konta organizacji</a
  >
</p>
<div class="py-4">
  <p-panel
    header="Mam wykreślone instytucje w Rejestrze Żłobków"
    [toggleable]="true"
    [toggler]="'header'"
    [collapsed]="true"
    (collapsedChange)="onCollapsedFirstPanelChange($event)"
  >
    <ng-template #headericons>
      <p-button
        [icon]="firstPanelToggled() ? 'pi pi-plus' : 'pi pi-minus'"
        severity="secondary"
        [pTooltip]="firstPanelToggled() ? 'Rozwiń' : 'Zwiń'"
        [attr.aria-label]="firstPanelToggled() ? 'Rozwiń' : 'Zwiń'"
        tooltipPosition="top"
        rounded
        text
      >
        <span class="sr-only">
          {{ firstPanelToggled() ? 'Rozwiń' : 'Zwiń' }}
        </span></p-button
      >
    </ng-template>
    <p>
      <strong>Konto organizacji założysz za pomocą formularza RKZ-2</strong> -
      jeśli posiadasz przynajmniej jedną wpisaną instytucję opieki w rejestrze
      żłobków i klubów dziecięcych lub w wykazie dziennych opiekunów.
      <strong
        >Wniosek może złożyć wyłącznie WŁAŚCICIEL podmiotu prowadzącego za
        pomocą dostępnej opcji „Dane właściciela”</strong
      >.
    </p>
    <p>
      Uruchamiając formularz jako osoba fizyczna będziesz mieć możliwość
      zgłoszenia danych właściciela podmiotu oraz podania numeru rachunku
      bankowego podmiotu prowadzącego instytucję opieki. Wniosek z opcją „Dane
      właściciela” służy wyłącznie do założenia konta organizacji. Ewentualna
      zmiana lub aktualizacja dotychczasowych danych podmiotu i instytucji
      możliwa będzie wyłącznie z kontekstu utworzonego konta organizacji.
    </p>
    <p>
      Poniższy link poprowadzi Cię przez proces rejestracji będący jednocześnie
      wnioskiem o założenie konta organizacji. Wniosek jest składany do urzędu w
      gminie, na terenie której funkcjonują żłobki, kluby dziecięce lub dzienni
      opiekunowie . Jeżeli posiadasz kilka instytucji opieki znajdujących się na
      terenie różnych gmin, wniosek o założenie konta organizacji złóż do
      wybranego (dowolnego) urzędu odpowiadającego gminie, w której znajduje się
      jedna z instytucji opieki. Po rozpatrzeniu wniosku dostaniesz wiadomość
      e-mail na adres podany w formularzu z informacją o założeniu konta
      organizacji lub o negatywnym jego rozpatrzeniu. W sprawie wniosku o
      założenie konta organizacji należy kontaktować się z urzędem, do którego
      złożono wniosek.
    </p>

    <div class="flex justify-between panel-buttons">
      <div>
        <span class="font-bold">RKZ-2</span> Zmiana danych w rejestrze żłobków
      </div>
      <div>
        <p-button
          label="Złóż wniosek"
          styleClass="customInfoButton"
          (click)="navigateToApplication(ApplicationCode.RKZ_2)"
          size="small"
        />
      </div>
    </div>
  </p-panel>
</div>
<div>
  <p-panel
    header="Nie masz wpisanej instytucji do Rejestru Żłobków"
    [toggleable]="true"
    [toggler]="'header'"
    [collapsed]="true"
    (collapsedChange)="onCollapsedSecondPanelChange($event)"
  >
    <ng-template #headericons>
      <p-button
        [icon]="secondPanelToggled() ? 'pi pi-plus' : 'pi pi-minus'"
        severity="secondary"
        [pTooltip]="secondPanelToggled() ? 'Rozwiń' : 'Zwiń'"
        [attr.aria-label]="firstPanelToggled() ? 'Rozwiń' : 'Zwiń'"
        tooltipPosition="top"
        rounded
        text
      >
        <span class="sr-only">
          {{ firstPanelToggled() ? 'Rozwiń' : 'Zwiń' }}
        </span></p-button
      >
    </ng-template>
    <p>
      <strong>Konto organizacji założysz za pomocą formularza RKZ-1</strong> -
      jeśli nie posiadasz żadnej wpisanej instytucji opieki w rejestrze żłobków
      i klubów dziecięcych lub w wykazie dziennych opiekunów.
      <strong
        >Wniosek może złożyć wyłącznie WŁAŚCICIEL podmiotu rejestrujący
        instytucję opieki</strong
      >.
    </p>
    <p>
      Poniższy link poprowadzi Cię przez proces rejestracji będący jednocześnie
      wnioskiem o założenie konta organizacji. Wniosek jest składany do urzędu w
      gminie, na terenie której będą znajdować się żłobki, kluby dziecięce lub
      dzienni opiekunowie. Po rozpatrzeniu wniosku dostaniesz wiadomość e-mail
      na adres podany w formularzu z informacją o założeniu konta organizacji
      lub o negatywnym jego rozpatrzeniu. W sprawie wniosku o założenie konta
      organizacji należy kontaktować się z urzędem, do którego złożono wniosek
    </p>
    <p>
      Konto organizacji zostanie założone tylko w przypadku pozytywnego
      rozpatrzenia Twojego wniosku przez urząd w <strong>gminie</strong>, na
      terenie której znajdują się żłobki, kluby dziecięce lub dzienni
      opiekunowie (RKZ-2) lub będą się znajdowały (RKZ-1).
    </p>
    <div class="flex justify-between panel-buttons">
      <div><span class="font-bold">RKZ-1</span> Wpis do rejestru żłobków</div>
      <div>
        <p-button
          label="Złóż wniosek"
          styleClass="customInfoButton"
          (click)="navigateToApplication(ApplicationCode.RKZ_1)"
          size="small"
        />
      </div>
    </div>
  </p-panel>
</div>
